import { render, staticRenderFns } from "./editBuild.vue?vue&type=template&id=0a253266&"
import script from "./editBuild.vue?vue&type=script&lang=js&"
export * from "./editBuild.vue?vue&type=script&lang=js&"
import style0 from "./editBuild.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports